// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../../../../../../../node_modules/@rsbuild/core/compiled/css-loader/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../../../../node_modules/@rsbuild/core/compiled/css-loader/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.bgY41_zEULk_zLPbMyrp{flex-direction:column;gap:40px;padding-top:16px;display:flex}._kO0ZCCe2BIek0EeQJRK{padding-top:32px;padding-bottom:32px}`, ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"content": `bgY41_zEULk_zLPbMyrp`,
	"actions": `_kO0ZCCe2BIek0EeQJRK`
};
export default ___CSS_LOADER_EXPORT___;
